module.exports = __webpack_public_path__ + "img/badge_gray_cap-foundation.d5bb5ad8.svg";